export default __webpack_public_path__ + "static/media/send.2e96348b.png";